module.exports = __webpack_public_path__ + "assets/img/mecha-e7e384b0.png";